const CITIES = [
  "Abbottabad",
  "Ahmedpur East",
  "Arifwala",
  "Attock",
  "Bahawalnagar",
  "Bahawalpur",
  "Bannu",
  "Batkhela",
  "Bhalwal",
  "Burewala",
  "Chakwal",
  "Chaman",
  "Charsadda",
  "Chichawatni",
  "Chiniot",
  "Daska",
  "Dera Ghazi Khan",
  "Dera Ismail Khan",
  "Faisalabad",
  "Ghotki",
  "Gojra",
  "Gujranwala",
  "Gujrat",
  "Hafizabad",
  "Haripur",
  "Hasilpur",
  "Hyderabad",
  "Islamabad",
  "Jacobabad",
  "Jaranwala",
  "Jhang",
  "Jhelum",
  "Kamalia",
  "Kamoke",
  "Kamra",
  "Karachi",
  "Kasur",
  "Khairpur",
  "Khanewal",
  "Khanpur",
  "Kharian",
  "Khushab",
  "Kohat",
  "Kot Addu",
  "Lahore",
  "Lalamusa",
  "Larkana",
  "Lodhran",
  "Mansehra",
  "Mardan",
  "Mian Channu",
  "Mianwali",
  "Mingora",
  "Mirpur",
  "Mirpur Khas",
  "Multan",
  "Murid",
  "Muridke",
  "Muzaffarabad",
  "Muzaffargarh",
  "Nankana Sahib",
  "Narowal",
  "Nawabshah",
  "Nowshera",
  "Okara",
  "Pakpattan",
  "Pasrur",
  "Pattoki",
  "Peshawar",
  "Quetta",
  "Rahim Yar Khan",
  "Rawalpindi",
  "Risalpur",
  "Sadiqabad",
  "Sahiwal",
  "Sambrial",
  "Samundri",
  "Sargodha",
  "Shahdadkot",
  "Sheikhupura",
  "Shikarpur",
  "Shorkot",
  "Sialkot",
  "Sukkur",
  "Swabi",
  "Swat",
  "Tando Adam",
  "Tando Allahyar",
  "Taxila",
  "Timergara",
  "Toba Tek Singh",
  "Turbat",
  "Umerkot",
  "Vehari",
  "Wah Cantt",
  "Wazirabad",
  "Zhob",
];

export default CITIES;
